import React from 'react';
import { useSaveReviewMutation } from 'api/individual-profile';
import { useSelector } from 'react-redux';
import { getUserStatusSelector } from 'store/login.slice';
import { ReviewForm, Reviews } from './sections';
import { Loader } from 'components/ui';
import styles from './UserReviewsTab.module.scss';
function UserReviewsTab({ isCurrentUserProfile, profileId, currentProfileId }) {
  const userStatus = useSelector(getUserStatusSelector);
  const [saveReview, { isLoading: isSaving }] = useSaveReviewMutation();
  const [renderForm, setRenderForm] = React.useState(true);

  if (isSaving) return <Loader section={true} />;
  return (
    <div className={styles['fade-in']}>
      <Reviews
        profileId={profileId}
        currentProfileId={currentProfileId}
        isCurrentUserProfile={isCurrentUserProfile}
        setRenderForm={setRenderForm}
      />
      {!isCurrentUserProfile && renderForm && (
        <ReviewForm profileId={profileId} userStatus={userStatus} saveReview={saveReview} />
      )}{' '}
    </div>
  );
}

export default UserReviewsTab;
